<template>
<div v-html="value">
    
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import StringHelpers from '../helpers/StringHelpers'
import DateHelpers from '../helpers/DateHelpers'
// import JexlHelpers from '../helpers/JexlHelpers'
// import Jexl from 'Jexl'

export default {
    data() {
        return {
            value: ''
        }
    },

    components: {
        
    },
    
    props: {
        row: Object,
        field: Object,
    },

    computed: {
        
    },

    methods: {
        calculateValue() {
            //const fieldId = StringHelpers.toCamelCase(this.field.name)
            
            const fieldId = this.field.identifier
            let value = this.row[fieldId] || ''
            if(this.field.type == 'Currency')
                value =  StringHelpers.formatCurrency(value)
            else if(this.field.type == 'Date')
                value = DateHelpers.backwardsToAu(value)
            else if(this.field.type == 'Calculated') {
                value = 'loading...'

                // Jexl.eval(this.field.expression, this.row).then(res => {
                //     this.value = res
                // })
            } else if(this.field.type == 'Image' && value) {
                value = `<img src="${value}" height="50" width="50" class="round white-border shadow"/>`
            }
               
            this.value = value            
        },
        loadTransforms() {

        }
    },

    created() {
        this.calculateValue()
    },

    watch: {
        'row': {
            deep: true,
            handler: function(newVal) {
                this.calculateValue()
            }
        }
    }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// Merger.vue?2374f1ad